import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpIcon from "@mui/icons-material/Help";
import { getBusStandTransSummeryReportData } from "../../redux/KSRTC_Redux/ReportsPage/ReportsAction";
import moment from "moment";
export const reportDateTimeFormat = 'DD-MMM-YYYY HH:mm'
export const reportDateFormat = 'DD-MMM-YYYY'
export const urls = {
  getRolesList: `/User/RolesListAll`,
  getUserList: `/User/UsersListAll`,
  getBusStationListAll: `/Master/BusStationListAll?`,
  getplaceListAll: `/Master/Places?`,
  getCargoCityList: `/Cargo/CargoCitiList?`,
  userRoleInsertUpdate: `/User/RolesInsertUpdate`,
  getCorporationList: `/Master/CorporationList`,
  userManangeDelete: `/User/UsersDelete?`,
  getMasterCountersListAll: `/Master/CountersListAll?`,
  userManageInsertUpdate: `/User/UsersInsertUpdate`,
  getBTobBToCUserAll: `/User/B2bB2CUserAll`,
  BToBBToCUserInsertUpdate: `/User/B2bB2CUserInsertUpadte`,
  BToBBToCUserDelete: `/User/B2bB2CUserDelete`,
  //login api
  //common api
  IDProofMasterListAll: `/Common/IDProofMasterListAll`,
  // service master urls
  getBusStationName: `/Common/BranchesListAll`,
  getServiceTripCode: `/RouteService/GetTripListAllForFilter`,
  getServiceCategory: `/RouteService/GetServiceCategoryListAll`,
  // getServiceManageTableData: `/RouteService/GetServiceListAll`,
  getServiceManageTableData: `/RouteService/GetServiceListAllV3`,
  getServiceDepotList: `/Common/CompaniesListAll`,
  getServiceLayoutList: `/Common/CompanyChartsListAll`,
  getServiceRouteDetails: `/RouteService/GetRouteLegsSubroutesList`,
  getServiceRouteDetailsV2: `/RouteService/GetRouteLegsSubroutesListV2`,
  getServiceStopTypeList: `/Common/ServiceStopTypeListAll`,
  getServiceMasterSave: `/RouteService/ServiceTrip_InsertUpdate`,
  getServiceMasterSaveV2: `/RouteService/ServiceTripCreate_InsertUpdate`,
  getServiceBoardingPoint: `/Common/PickupsListAll`,
  getServiceDroppingPoint: `/Common/DropoffsListAll`,
  getManageServiceDelete: `/RouteService/DeactivateService`,
  getEditManageService: `/RouteService/GetServiceTripDetails`,
  getManageServiceDepotSave: `/RouteService/ServiceManageDepot_Update`,
  getManageServiceDepotSaveV2: `/RouteService/ServiceManageDepot_UpdateV2`,
  getManageServiceDepotTable: `/RouteService/ServiceManageDepot_List`,
  getManageServiceDepotDelete: `/RouteService/ServiceManage_DeleteDepot`,
  getManageServiceSheduleSave: `/RouteService/ServiceManageSchedule_Update`,
  getManageServiceSheduleTable: `/RouteService/ServiceManageSchedule_List`,
  getManageServiceSheduleDelete: `/RouteService/ServiceManage_DeleteScheduleData`,
  getManageServiceCategoriesSave: `/RouteService/ServiceManageServType_Update`,
  getManageServiceCategoriesSaveV2: `/RouteService/ServiceManageServType_UpdateV2`,
  getManageServiceCategoriesTable: `/RouteService/ServiceManageServType_List`,
  getManageServiceCategoriesDelete: `/RouteService/ServiceManage_DeleteServiceType`,
  getManageServiceRouteHaltSave: `/RouteService/ServiceManageHaltRoute_Update`,
  getManageServiceRouteHaltTable: `/RouteService/ServiceManageHaltRoute_List`,
  getManageServiceRouteHaltDelete: `/RouteService/ServiceManageHaltRoute_Delete`,
  getManageServicePickupPointSave: `/RouteService/ServiceManagePickups_InsertUpdate`,
  getManageServicePickupPointSaveV2: `/RouteService/ServiceManagePickups_InsertUpdateV2`,
  getManageServicePickupPointTable: `/RouteService/ServiceManagePickups_ListAll`,
  getManagePickupPointData: `/Common/PickupsListAll`,
  getManageServicePickupPointDelete: `/RouteService/ServiceManagePickups_Delete`,
  getServiceCancelTypes: `/RouteService/ServiceCancelTypes`,
  getServiceCancelList: `/RouteService/ServiceCancelListAll`,
  serviceCancelInsert: `/RouteService/ServiceCancel_Insert`,
  getServiceManageIncentiveList: `/RouteService/ServiceManageIncent_List`,
  getServiceManageIncentDelete: `/RouteService/ServiceManage_DeleteIncent`,
  getServiceManageIncentUpdate: `/RouteService/ServiceManageIncent_Update`,
  getServiceManageFranchiseList: `/RouteService/ServiceManageFranIncent_List`,
  getServiceManageFranchiseDelete: `/RouteService/ServiceManage_DeleteFranIncent`,
  getServiceManageFranchiseUpdate: `/RouteService/ServiceManageFranIncent_Update`,
  getRouteListV2: `/Common/APIServiceRouteAvailable_List`,
  getServiceCityList: `/Common/APICityyPairFromAvailRoutes_List`,
  getManageRouteHaltSave: `/RouteService/ServiceManageHaltRoute_UpdateV2`,
  getManageRouteHaltSaveV3: `/RouteService/ServiceManageHaltRoute_UpdateV4`,
  serviceCancelRevoke: `/RouteService/ServiceCancelRevoke_Insert`,
  copyServiceSave: `/RouteService/ServiceManageCopy_InsertUpdate`,
  checkServiceTripCode: `/RouteService/ServiceTripCodeValidation`,
  getServiceDepotListV2: `/Common/GetAllDepotCompanies`,
  // getServiceDepotListV2: `/Common/GetAllDepotCompaniesV2`,
  getBusStationListAllV2: `/Master/BusStationListAllV2?`,
  getIncentiveCodeFRINC: `/RouteService/ServiceManageFranIncent_FilterList`,
  // getAPICityyPairFromAvailRoutes: `/RouteService/GetServiceCityPairActiveForManage`,
  //manage stock
  getManageStockTableData: `/Stock/StocksListAll`,
  getManageStockSave: `/Stock/StockInsertUpdate`,
  deleteManageStockSave: `/Stock/StockDelete`,
  getIssueStockTableData: "/Stock/IssueStocksListAll",
  getIssueStockSave: `/Stock/IssueStockInsertUpdate`,
  getIssueStockCounterList: `/Master/CountersListAll`,
  getCurrentStock: `/Stock/BranchCurrentStock`,
  getSkipStockList: `/Stock/SkipStocksListAll`,
  getSkipStockSave: `/Stock/SkipStockInsertUpdate`,
  getTransferStockList: `/Stock/TransferStocksListAll`,
  getTransferStockSave: `/Stock/TransferStockInsertUpdate`,
  //Manage PPR
  getManagePprTableData: `/Stock/CargoPPRListAll`,
  getManagepprSave: `/Stock/CargoPPRInsertUpdate`,
  IssueCargoPPRListAll: `/Stock/IssueCargoPPRListAll`,
  CargoPPRDetailsCounter: `/Stock/CargoPPRDetailsCounter`,
  CargoPPRDetailsInsertUpdate: `/Stock/CargoPPRDetailsInsertUpdate`,
  TransferPPRListAll: `/Stock/TransferPPRListAll`,
  TransferPPRInsertUpdate: `/Stock/TransferPPRInsertUpdate`,

  SkipPPRsListAll: '/Stock/SkipPPRsListAll',
  SkipPPRInsertUpdate: `/Stock/SkipPPRInsertUpdate`,
  //master config
  getMasterCountersListAll: `/Master/CountersListAll?`,
  getBusStationListAll: `/Master/BusStationListAll?`,
  getplaceListAll: `/Master/Places?`,
  getCargoCityList: `/Cargo/CargoCitiList?`,
  getStatesList: `/Master/States`,
  getStatesInsertUpdate: `/Master/StateInsertUpdate`,
  getStatesDelete: `/Master/StateDelete`,
  getCorporationList: `/Master/CorporationList`,
  getCorporationInActive: `/Master/CorporationInactive`,
  getCorporationInsertUpdate: `/Master/SaveCorporation`,
  getLeviesListAll: `/Master/LeviesListAll`,
  getCorporationLeviesListAll: `/Master/CorporationLeviesListAll`,
  getLeviesInsertUpdate: `/Master/CorporationLeviesInsertUpdate`,
  getLeviesDelete: `/Master/CorporationLeviesDelete`,
  getConcessionListAll: `/Master/ConcessionTypesListAll`,
  getCorpConcessionList: `/Master/CorporationConcessionListAll`,
  getCorpConcessionInsertUpdate: `/Master/CorporationConcessionInsertUpdate`,
  getCorpConcessionDelete: `/Master/CorporationConcessionDelete`,
  getCorpConcessionDetailsDelete: `/Master/CorporationConcessionDetailsDelete`,
  getClassTypeList: `/Master/ClassTypeListAll`,
  getPlacesInsertUpdate: `/Master/PlaceInsertUpdate`,
  gePlaceDelete: `/Master/PlaceDelete`,
  counterDelete: "/Master/CounterDelete?",
  counterInsertUpdate: "/Master/CounterInsertUpdate?",
  getCrewListAll: `/Master/CrewListAll`,
  getDepotList: `/Master/DepotListAll`,
  crewDelete: "/Master/CrewDelete",
  crewInsertUpdate: `/Master/CrewInsertUpdate?`,
  getdivisionFilterList: `/Master/DivisionListAll`,
  divisionDelete: `/Master/DivisionDelete?`,
  divisionInsertUpdate: `/Master/DivisionInsertUpdate?`,
  depotInsertUpdate: `/Master/DepotInsertUpdate?`,
  depotDelete: `/Master/DepotDelete?`,
  busStationInsertUpdate: `/Master/BusStationInsertUpdate`,
  busStationDelete: `/Master/BusStationDelete`,
  getClassTypeMasterList: `/Master/ClassTypeMasterListAll`,
  classTypeInsertUpdate: `/Master/ClassTypeListInsertUpdate?`,
  classTypeDetailsDelete: `/Master/ClassTypeDetailsDelete`,
  classTypeDelete: `/Master/ClassTypeDelete`,
  getConcessionTypesListAll: `/Master/ConcessionTypesListAll`,
  getVehicleMasterTableData: `/Vehicle/MasterBusesListAll`,
  getCompanyChartsListAll: `/Vehicle/CompanyChartsListAll`,
  getVehicleMacList: `/Vehicle/OEMListAll`,
  CompanyChartsGetChartLayout: `/Vehicle/CompanyChartsGetChartLayout`,
  BusesInsertUpdate: `/Vehicle/BusesInsertUpdateV2`,
  getGroupDiscountData: `/Groupdiscount/GroupdiscountList`,
  groupDiscountInsertUpdate: `/Groupdiscount/AddTopUp`,
  // Route master
  getRouteList: `/RouteService/GetRouteList`,
  getCityList: `/GetCompanyCityList`,
  getClassTypeListForRoute: `/RouteService/GetServiceCategoryListAll`,
  addRoute: `/RouteService/RouteName_InsertUpdate`,
  addRouteLegs: `/RouteService/RouteLegs_InsertUpdateAll`,
  getRouteLegsList: `/RouteService/RouteLegsList`,
  getLinkedRoutes: `/RouteService/GetLinkedRoutes`,
  //Route levies
  updateLinkRoute: `/RouteService/LinkRoute_InsertAll`,
  getRouteLeviesList: `/RouteService/RouteLevies_ListAll`,
  routeLeviesInsertUpdate: `/RouteService/RouteLevies_InsertUpdate`,
  getRouteLevyType: `/Common/LeviesListAll`,

  //Dashboard
  getDashboardData: `/Dashboard/GetHistoricalDashboardDataV2`,
  getFutureDashboardData: `/Dashboard/GetFutureDashboardDataV2`,

  //Booking page
  getCompanyCityPairs: `/BookingSearch/CompanyCityPairs`,
  getSearchRoutes: `/BookingSearch/SearchRoutes`,
  getSearchRoutesBlockSeats: `/BookingSearch/SearchRoutes_Block`,
  getPickupsDropoffs: `/BookingSearch/PickupsDropoffs`,
  getChart: `/BookingSearch/APIGetChart`,
  getBkgConcessionsLevies: `/BookingSearch/ConcessionsLevies`,
  getBookingPrintData: `/Print/BookingDetailsToPrint?`,
  getTicketNumber: `/Stock/IssueStocksCounter?`,
  getCounterBooking: `/OnwardReturnCounterBooking?`,
  getCounterBooking1: `/CounterBooking?`,
  getCountryList: `/Common/Countries?`,
  getPaymentModesListAll: `/Common/PaymentModesListAll`,
  getTripCodeDet: `/BookingSearch/APIMSTripsSummaryPkpDrp`,
  //Trip sheet
  getBusList: `/Common/BusesListAll`,
  addTripSheet: `/Report/KATripSheetGenerateDetails_InsertUpdate`,
  getTripSheetTableData: `/Report/GetTripSheetDetails`,
  getTripSheetViewData1: `/Report/GenerateTripsDetails`,
  getTripSheetViewData2: `/Report/GenerateTripSheetViewV2`,
  //track Ticket
  getTrackTicketData: `/Print/TrackTicket`,
  getTrackTicketMobileData: `/Print/GetPNRSearchListV2`,
  getBookingDetailsPrint: `/Print/BookingDetailsToPrint`,
  getTrackTicketSms: `/Print/TrackTicketSendSMSEmailV2`,
  //Lock/Unlock PNR
  getPnrLockUnlock: `/LockPNR`,
  printTicket: `/Print/BookingDetailsToDuplicateTicket`,
  //ad-hoc refund
  getAdocSearchList: `/Common/APIGetPNRListAll`,
  // adhocRefund: `/Cancellation/AdhocRefundInsertUpdate`,
  adhocRefund: `/Cancellation/AdhocRefundRequestInsertUpdate`,
  getBookingBalance: `/Common/BranchesListAll`,
  cancelTicket: `/Cancellation/CancelTicket`,
  cancelTicketV4: `/Cancellation/CancelTicketV4`,
  getPassengersSeatDetails: `/Common/APIGetBookingDetails`,
  //transfer Seat
  getTripListAllForFilter: `/RouteService/GetTripListAllForFilter`,
  getDataForSeatTransfer: `/TransferSeat/GetDataForSeatTransfer`,
  getTransferSeatSave: `/TransferSeat/TransferSeat`,
  getBlockSeat: `/BlockSeat/OnwardReturnSeatBlock`,
  getBlockSeat1: "/BlockSeat/SeatBlock",
  getBlockList: `/BlockSeat/BlockListing`,
  setUnBlock: `/BlockSeat/SeatUnBlock`,
  //E-ticket
  getCancelReqList: `/Cancellation/CancelRequestTypes`,
  getCancelEticketList: `/Cancellation/CancelRequestLists`,
  getDataForBlockToConfirm: `/BlockSeat/GetDataForBlockToConfirm`,
  //others tab
  getServiceCancelListOnline: `/RouteService/ServiceCancelListAllOnline`,
  getServiceCancelUpdate: `/RouteService/ServiceCancel_UpdateOnlineV2`,
  //penalty
  getFranchiseUserList: `/Penalty/FranchiseBranchUser_ListAll`,
  getPenaltySearchList: `/Penalty/FranchisePanelty_ListAll`,
  getPenaltyInsert: `/Penalty/FranchisePanelty_Insert`,
  getUserWiseCollection: `/Report/BookingsUserWiseCollV2`,

  //Prepone/postpone ticket
  getDataForPreponePostpone: "/TicketModification/GetDataForPreponePostpone",
  UpdatePreponePostPone: `/TicketModification/PreponePostPoneV2`,

  getDataForModification: `/TicketModification/GetDataForModification`,
  UpdateModifyPickupDropOff: `/TicketModification/ModifyPickupDropOff`,

  //others tab
  getTicketModification: `/TicketModification/GetDataForModification`,
  getTicketModify: `/TicketModification/TicketModification`,
  updateBlockToConfirm: `/BlockSeat/BlockToConfirm`,
  getSentLink: `/BlockSeat/SentLink`,
  getDelaySms: `/Report/TripsScheduledListAllByJD`,
  getDelaySmsPNRTckt: `/Report/BusrelsmsPaxdetail`,
  getManageQuotaSeatTable: `/RouteService/ServiceManageQuota_List`,
  getManageQuotaSeatSave: `/RouteService/ServiceManageQuota_Update`,
  getManageQuatoSeatDelete: `/RouteService/ServiceManage_DeleteQuota`,
  getManageRoutesQuotaTable: `/RouteService/ServiceManageRouteQuota_List`,
  getManageRouteQuatoSeatDelete: `/RouteService/ServiceManage_DeleteRouteQuota`,
  getAPICityyPairFromAvailRoutes: `/Common/APICityyPairFromAvailRoutes_List`,
  getAPICityyPairFromAvailRoutesV2: `/Common/APICityPairAvailRouteOnly_List`,

  getManageRouteQuotaSeatSave: `/RouteService/ServiceManageRouteQuota_Update`,
  sendDelaySms: `/Report/BusRelatedSMSUpdate`,
  //current Ticket Booking
  getSearchRoutesOffline: "/BookingSearch/SearchRoutesOffline",
  updateCurrentBooking: `/CurrentBooking/CurrentBookingV2`,
  getCurrBookingPrintData: `/Print/CurrentBookingDetailsToPrint`,
  getTimeTable: `/Other/GetTimeTable`,
  insertUpdateTimeTable: `/Other/SetTimeTable`,

  //Boarding point Url
  // getBoardingData: `/Master/PickupDropoffsListAll`,
  getBoardingData: `/Master/PickupDropoffsListAllV3`,
  getAreaListData: `/Common/AreasListAll`,
  getBoardingDataSave: `/Master/MasterBoardingdropping_InsertUpdate`,
  getBoardingDataSaveV2: `/Master/MasterBoardingdropping_InsertUpdateV2`,
  //manage news
  getManageNewsInsert: `/ManageNews/ManageNews_InsertUpdateV2`,
  getManageNewsSearchList: `/ManageNews/ManageNews_ListAllV2`,
  //Top Up
  getTopUpList: `/Topup/GetTopupdetails`,
  getAddTopUp: `/Topup/AddTopUp`,
  getViewTopUp: `/Topup/ViewTopupdetails`,
  //layout
  getChartList: `/Vehicle/CompanyChartsListAll`,
  getChartLayoutDetails: `/Vehicle/CompanyChartsGetChartLayout`,
  chartInsert: `/Vehicle/ChartsInsertV2`,
  updateCreateChart: `/Vehicle/CompanyChartUpdate`,
  deActivChart: `/Vehicle/CoachActiveDeActive`,
  addChart: `/Vehicle/CompanyChartInsertV2`,
  //layout quota
  getLayoutQuotaList: `/LayoutConfig/LayoutQuota_List`,
  updateLayoutQuotaSeats: `/LayoutConfig/LayoutQuota_Update`,
  deleteQuotaSeats: `/LayoutConfig/Layout_DeleteQuota`,
  //Reports
  getGstReportData: `/Report/GSTReport`,
  getBusStandTransSummeryReportData: `/Report/BusStationWiseTransactionReport`,
  getStatementOfAccountsForSaleOfTickets: `/OtherReport/StatementOfAccountsReport`,
  getPrePondPostGnReportData: `/GeneralReport/PreponePostponeSummary`,
  getPrePondPostACReportData: `/AccountReport/PreponePostponeDetails`,
  getCocessionTicketReport: `/GeneralReport/CocessionTicketReport`,
  getCancelledTicketReport: `/Report/CancelledTicketReport`,
  getFranchiseeDepositReportData: `/OtherReport/FranchiseeDepositReport`,
  getGenAIReport: `/OtherReport/GetGenAIReport`,
  getMonthlyPassReport: `/OtherReport/GetPassReport`,
  getONBGWBSSReportData: `/OnlineReports/GetGatewayWiseBkgSuccessRptV2`,
  getPOSBankGatewayReportData: `/GeneralReport/GetPOSFailureTxnReport`,
  getONBGWPTReportData: `/OnlineReports/GetGatewayWiseBkgPendingRptV2`,
  getDateWiseTrnGNReportData: `/Report/GetDateWIseTranDataRpt`,
  ///getAdhocRefundDetailsReport: `/Report/GetAdhocRefDataRpt`,
  getAdhocRefundDetailsReport: `/Report/GetAdhocRefDataRptV2`,
  getDepotDivisionWiseData: `/Report/GetDepotDivisionWIseDataRpt`,
  partialCancelledTicketReportData: `/AccountReport/PartialCancelledTicketReport?`,
  FullCancelledTicketReportData: `/AccountReport/FullCancelledTicketReport`,
  getReservationChartReportData: `/GeneralReport/ReservationChartReport`,
  getOnlineBulkRefundData: `/OnlineReports/GetOnlineBulkRefRptV2`,
  getCorporationWiseNoOfServices: "/Report/GetCorpWiseServiceRpt",
  getRegularServicesList: "/Report/GetGetRegularServiceRpt",
  updateTopUpRezorpay: "/Topup/AddTopUpRezorpay",
  confirmRecharge: "/Topup/ConfirmRecharge",
  getCounterWiseResCollData: `/Report/GetDepoWIseTranDataRpt`,
  pGModeWiseEBookingTransaction: "/AccountReport/PGModeWiseTransactionReportV2",
  getPgEBkngTransactionData: `/AccountReport/PGEBookingTransactionReportV2`,
  getDateWiseMonthlyTransactionRptData: `/AccountReport/DateWiseTXMonthlyReport`,
  getRevenueGivenToOtherDivisionsTblData: `/Report/BusStationWiseGivenRVReport`,
  getRevenueReceiveFromOtherDivisionsTblData: `/Report/BusStationWiseReceiveRVReport`,
  getCounterWiseRevSummaryTblData: `/GeneralReport/CounterWiseRevSummaryReport`,
  getBoardingPointwiseReport: `/GeneralReport/BoardingPointwiseReport`,
  getTopupSuccessFailureReport: `/OtherReport/TopupSFDetailReport`,
  getGNTPRefundReportData: `/GeneralReport/TicketPendingRefundReportV2`,
  getReconciliationReport: `/AccountReport/ReconciliationStatementReport`,
  getEbookingDetSummary: `/OnlineReports/EBookingDetailsSummaryV2`,
  getMonthalyDetSummary: `/OnlineReports/EBookingDetailsMonthSummaryV2`,
  getCancelTransactionSummary: `/OnlineReports/CancelledTransactionSummary`,
  getSpecialServiceRtpData: `/GeneralReport/GetSPServiceRpt`,
  getIncomeEarnServiceNotRenderdRptData: `/OtherReport/IncErnSRRReport`,
  getDailyStockConsumptionReport: `/GeneralReport/StockConsumptionReport`,
  getBookingSummaryForGivenPeriodReport: `/GeneralReport/GetBookingSummaryGivenPeriod`,
  getBookedSeatDepotWiseReport: `/GeneralReport/BookedSeatDepotWiseOccPerReport`,
  getDateWiseRevenueReport: `/GeneralReport/GetDateWiseRevenueReport`,
  getSpecialIncentivesMasterTable: `/GeneralReport/SpecialIncentive_MasterDetails`,
  getTicketsCancelledAfterAdvanceBookingisStoppedReport: `/GeneralReport/TicketCancelAdvanceBookStopReport`,
  getServiceCancAfterJourneyDateReportData: `/OtherReport/ServiceCnclJourneyDateReport`,
  getStationWiseServiceType: `/GeneralReport/StationDepotWiseReportResponse`,
  getFranchiseeCommissionDiffReportData: `/OtherReport/FranchiseeCommissionDifferenceReport`,
  getServiceReport: `/GeneralReport/Service_Route`,
  getFareMasterSummaryReport: `/GeneralReport/FareMasterSummaryReport`,
  getLevySlabwiseCollectionSeatsBookedSummary: `/OtherReport/LevySlabColl_SeatsBooked`,
  getBlockUnblocklogReportData: `/GeneralReport/BlockUnblocklogReport`,
  getRevCollRepoCorpWise: `/GeneralReport/GetRevCollRepoCorpWise`,

  //Fare Master
  getKAFlexiListAll: `/Fare/GetKAFlexiListAll`,
  getSetFareDiscountListAll: `/Fare/GetSetFareDiscountListAll`,
  gettripdetailsforfarediscount: "/Fare/tripdetailsforfarediscount_all",
  updateFareDisount: "/Fare/SetFareDiscount_InsertUpdate",
  getKAFlexiListDetailsAll: "/Fare/GetKAFlexiListDetailsAll",
  getKAFlexiListDetailsAllOnGo: "/Fare/GetKAFlexiListDetailsAllOnGo",
  getCommsionGroupandTranLists: `/Fare/GetCommsionGroupandTranLists`,
  getFareGroupCommissionListAll: `/Fare/GetFareGroupCommissionListAll`,
  getFareUserCommGrpListAll: `/Fare/GetFareUserCommGrpListAll`,
  updateFareUser: "/Fare/FareUserCommGrp_InsertUpdate",
  getFareUserCommDiffListAll: "/Fare/GetFareUserCommDiffListAll",
  // updateFareUserCommDiff: "/Fare/FareUserCommDiff_InsertUpdate",
  updateFareUserCommDiff: '/Fare/FareUserCommDiff_InsertUpdateV2',
  updateFareCommGroup: "/Fare/FareGroupCommission_InsertUpdate",
  getFareUserCommDiffBasicAmount: '/Fare/GetFareUserCommDiffBasicAmount',
  getComonMasterTypesList: `/Fare/GetComonMasterTypesList`,
  getWeekDayPolicyList: `/Fare/WeekDayPolicyList`,
  updateWeekDay: "/Fare/FlexiPolicy_InsertUpdate",
  getCommonMasterTypesList: `/Fare/GetComonMasterTypesList`,
  getDateWiseFlexyConfig: `/Fare/GetFlexyConfigDateWise`,
  getFlexyConfigInsertUpdate: `/Fare/FlexyConfig_InsertUpdate`,
  getSeasonFareTblData: `/Fare/GetSeasonFareConfig`,
  getSeasonFareInsertUpdate: `/Fare/SeasonFareConfigInsertUpdate`,
  getRateMasterListAll: `/Fare/GenerateFareMasterStagesList`,
  getRateMasterEditListAll: `/Fare/GenerateFareMasterStages`,
  getRateMasterSave: `/Fare/SaveFareMasterStagesConfig`,
  updateFlexiList: "/Fare/KAFlexiListDetails_InsertUpdate",
  getBasicFareListAll: `/Fare/GetServiceTypeFareConfigV3`,
  getRoundOffListAll: `/Fare/GetComonMasterTypesList`,
  getBasicFareInsertUpdate: `/Fare/ServiceTypeFareConfigInsertUpdateV3`,
  getFareMasterListData: `/Fare/GetFareMasterListAll`,
  getTripCodeWiseRevReport: `/GeneralReport/TripCodeWiseRevReport`,
  getGSTCollectedCarriageServicesReport: `/OtherReport/GSTCollectedCarriageServicesReport`,
  getSummaryRevenueRealizedReport: `/OtherReport/RevenueRealizedSummaryReport`,
  getFranchiseeObcbSummaryReport: `/Report/GetFranchiseeOBCB_Summary`,
  getCancelledServiceReport: `/GeneralReport/GetCancelledServiceRpt`,
  getPassengerDetailReport: `/OtherReport/PassengerDetailReport`,
  getCorporationWiseSeatDetailReport: `/GeneralReport/CorporationWiseSeatDetailReport`,
  getPassengerBookingSummary: `/GeneralReport/GetPassengerBookingSummary`,
  getUserLoginHistoryReport: `/OtherReport/UserLoginHistoryReport`,
  getFranchiseeIncentiveSummaryReport: `/GeneralReport/FranchiseeIncentiveSummaryReport`,
  getBusStandWiseBookedETktReport: `/OnlineReports/BusStandWiseBookedETktReport`,
  getDepotWiseAdvanceBookingReport: `/GeneralReport/GetDepotWiseAdvBookingRpt`,
  getClasswiseSeatsReservedRevenueSharedReport: `/GeneralReport/ClasswiseSeatsReservedRevenueSharedReport`,
  getTripWiseBookedSeatSummaryReport: `/GeneralReport/GetTripWiseBookedSeatSummary`,
  getConcessionTicketSummaryReport: `/OtherReport/GetConcessionTicketSummaryReort`,
  getBusstandwiseFranchiseeCommisionReport: `/GeneralReport/BusStandWiseFranchiseeCommRpt`,
  getTravelinfoReport: `/OtherReport/TravelInfoReport`,
  getBusStationWiseServicesAndFranchiseeReport: `/GeneralReport/BusStandWiseServiceNFranchiseeRpt`,

  getAdvanceBookedSeatsRevenueReport: `/GeneralReport/GetAdvanceBookedSeatsRevenueReport`,
  getBookedSeatsSummaryDepotWiseReport: `/OtherReport/BookedSeatsSummaryDepotWise`,
  getStockSkipDetailsReport: `/OtherReport/StockSkipDetailsReport`,
  getForeignDomesticTravelInfoReport: `/GeneralReport/ForeignDomesticTravelInfoReport`,
  getCancelTktAdvanceBookStopReport: `/OtherReport/CancelTktAdvanceBookStopReport`,
  getCancellationSummaryData: `/OtherReport/CancellationSummarySlabBasedReport`,
  getBlockTicketReport: `/OtherReport/BlockTicketReport`,

  //audit
  getModuleListAll: `/Report/GetModule?`,
  getAuditReport: `/Report/AuditReport`,
  logoutUser: "/Logout",
  setCounterId: "/LoginV2/SetCounterID",

  getBookingType: "/OtherReport/GetBookingTypeList",
  getModeWiseOnlineTransactionReport:
    "/OtherReport/ModeWiseOnlineTransactionReport",
  getMasterCode: "/MasterCodes/MasterCodesListAll",
  MasterCodeInsertUpdate: "/MasterCodes/MasterCodeInsertUpdate",

  //Old PNR Ticket
  getOldTrackTicketData: `/Print/TrackTicketAwatar3`,
  getOldTrackTicketMobileData: `/Print/GetPNRSearchListAwatar3`,
  getFranchiseeCommissionSummaryReport: '/GeneralReport/FranchiseeCommissionSummaryReport',
  getFranchiseeDepRecDivisionReport: '/GeneralReport/FranchiseeDepRecDivisionReport',
  getTripListAllWithUserPrev: '/RouteService/GetTripListAllWithUserPrev',
  getServiceCancelTicketOtherReport: '/OtherReport/ServiceCancelTicketReport',
  getServiceCancelTicketGenReport: '/GeneralReport/ServiceCancelTicketReport',
  //Cargo ID proof Type
  IDProofMaster: `/Common/IDProofMasterListAll`,
  //cargo booking
  CargoBookingCharge: `/Cargo/CargoBookingCharges`,
  CargoBookingSave: `/CargoTransaction/CargoBooking`,
  CargoBookingSnapshotsSave: `/CargoTransaction/CargoBookingSnapshotsSave`,
  GetManifestDetails: `/Cargo/GetManifestDetails`,
  CargoVehicleDetails: `/Cargo/CargoVehicleDetails`,
  DriverConductorListAll: `/Common/DriverConductorListAll`,
  CargoDisatch: `/CargoTransaction/CargoDisatch`,
  GetCargoReceiptDetails: `/Cargo/GetCargoReceiptDetails`,
  CargoReceive: `/CargoTransaction/CargoReceive`,
  GetLuggageForDelivery: `/GetLuggageForDelivery`,
  CargoDelivery: `/CargoTransaction/CargoDelivery`,
  //cargo reports
  BookingReport: `/CargoReport/BookingReport`,
  ManifestReport: `/CargoReport/ManifestReport`,
  PartialManifestReport: `/CargoReport/PartialManifestReport`,
  ReceiveReport: `/CargoReport/ReceiveReport`,
  PartialReceiveReport: `/CargoReport/PartialReceiveReport`,
  DeliveryReport: `/CargoReport/DeliveryReport`,
  RemittanceReport: `/CargoReport/RemittanceReport`,

  getBookedSeatDetailsReport: "/GeneralReport/GetBookedSeatDetailsReport",
  getServiceCancelTicketGenReport: '/GeneralReport/ServiceCancelTicketReport',
  QuotaReleaseInsertUpdate: '/BlockSeat/QuotaRelease_InsertUpdate',

  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getCounterWiseBookingComparisonReport: '/GeneralReport/CounterWiseBookingComparisonReport',
  //Cargo ID proof Type
  IDProofMaster: `/Common/IDProofMasterListAll`,
  //cargo booking
  CargoBookingCharge: `/Cargo/CargoBookingCharges`,
  CargoBookingSave: `/CargoTransaction/CargoBooking`,
  CargoBookingSnapshotsSave: `/CargoTransaction/CargoBookingSnapshotsSave`,
  GetManifestDetails: `/Cargo/GetManifestDetails`,
  CargoVehicleDetails: `/Cargo/CargoVehicleDetails`,
  DriverConductorListAll: `/Common/DriverConductorListAll`,
  CargoDisatch: `/CargoTransaction/CargoDisatch`,
  GetCargoReceiptDetails: `/Cargo/GetCargoReceiptDetails`,
  CargoReceive: `/CargoTransaction/CargoReceive`,
  GetLuggageForDelivery: `/GetLuggageForDelivery`,
  CargoDelivery: `/CargoTransaction/CargoDelivery`,
  //cargo reports
  BookingReport: `/CargoReport/BookingReport`,
  ManifestReport: `/CargoReport/ManifestReport`,
  PartialManifestReport: `/CargoReport/PartialManifestReport`,
  ReceiveReport: `/CargoReport/ReceiveReport`,
  PartialReceiveReport: `/CargoReport/PartialReceiveReport`,
  DeliveryReport: `/CargoReport/DeliveryReport`,
  getPartialDeliveryReport: `/CargoReport/PartialDeliveryReport`,
  RemittanceReport: `/CargoReport/RemittanceReport`,
  getServiceWiseSeatAvailabilityReport: '/GeneralReport/ServiceWiseSeatAvailabilityReport',
  getTicketBlockConsumptionReport: '/GeneralReport/TicketBlockConsumptionReport',
  getHeighestBookingFromCityToCityReport: '/OtherReport/HeighestBookingFromCityToCityReport',
  getServiceTypeTransactionSummary: '/OtherReport/ServiceTypeTransactionSummary',
  QuotaReleaseInsertUpdate: '/BlockSeat/QuotaRelease_InsertUpdate',
  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getVacancySeatReport: '/Report/VacancySeatReport',
  //Product Type 
  CargoConsignmentList: `/Cargo/CargoConsignmentList`,
  ProductTypeInsertUpdate: `/Cargo/ProductTypeInsertUpdate`,
  //Transhipment charge
  TranshipmentListAll: `/Cargo/TranshipmentListAll`,
  TranshipmentChargeInsertUpdate: `/Cargo/TranshipmentChargeInsertUpdate`,
  //Cargo
  getConsignmentList: `/Cargo/CargoConsignmentList`,
  getCargoWeightListAll: `/Cargo/CargoWeightListAll`,
  weightInsertUpdate: `/Cargo/CargoWeightInsertUpdate`,
  getCargoKiloMeterListAll: '/Cargo/CargoKiloMeterListAll',
  kiloMeterInsertUpdate: `/Cargo/CargoKiloMeterInsertUpdate`,
  getLoadingUnloadingListAll: '/Cargo/LoadingUnloadingListAll',
  LoadingUnloadingChargeInsertUpdate: '/Cargo/LoadingUnloadingChargeInsertUpdate',
  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getPickupDropoffListAll: '/Cargo/PickupDropoffListAll',
  getPickupDropoffChargeListAll: '/Cargo/PickupDropoffChargeListAll',
  PickupDropoffChargeInsertUpdate: '/Cargo/PickupDropoffChargeInsertUpdate',
  getCargoKiloMeterListAll: '/Cargo/CargoKiloMeterListAll',
  getInsuranceChargeTable: `/Cargo/InsuranceChargeListAll`,
  getInsuranceChargeInsertUpdate: `/Cargo/InsurancechargeInsertUpdate`,
  getDemurrageChargeTable: `/Cargo/DemurrageListAll`,
  getDemurrageChargeInsertUpdate: `/Cargo/DemurrageChargeInsertUpdate`,
  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getShipmentWeightListAll: `/Cargo/ShipmentWeightLimitListAll`,
  getShipmentWeightInsertUpdate: `/Cargo/ShipmentWeightInsertUpdate`,
  getCargoCrewListAll: '/Cargo/CrewIncentiveListAll',
  CrewIncentiveInsertUpdate: `/Cargo/CrewIncentiveInsertUpdate`,
  getCargoTransportChargeListAll: '/Cargo/TransportchargeListAll',
  TransportchargeInsertUpdate: `/Cargo/TransportchargeInsertUpdate`,

  QuotaReleaseInsertUpdate: '/BlockSeat/QuotaRelease_InsertUpdate',

  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,

  //Content management system apis
  getCmsMenu: `/resource/getCMSmenuContent`,
  getCmsMainBannerImage: `/resource/getBannerImg`,
  insertCmsMainBannerImage: `/resource/uploadBannerImg`,
  getReservationTerms: `/resource/getReservationTermsContent`,


  getPopularDestination: `/resource/getPopulardestination`,
  getBookingCounter: `/resource/getBookingCounterContent`,
  getCmsCityList: `/resource/getStaticCityList`,

  getServiceCancelTicketOtherReport: '/OtherReport/ServiceCancelTicketReport',
  getServiceCancelTicketGenReport: '/GeneralReport/ServiceCancelTicketReport',
  //Cargo ID proof Type
  IDProofMaster: `/Common/IDProofMasterListAll`,
  //cargo booking
  CargoBookingCharge: `/Cargo/CargoBookingCharges`,
  CargoBookingSave: `/CargoTransaction/CargoBooking`,
  CargoBookingSnapshotsSave: `/CargoTransaction/CargoBookingSnapshotsSave`,
  GetManifestDetails: `/Cargo/GetManifestDetails`,
  CargoVehicleDetails: `/Cargo/CargoVehicleDetails`,
  DriverConductorListAll: `/Common/DriverConductorListAll`,
  CargoDisatch: `/CargoTransaction/CargoDisatch`,
  GetCargoReceiptDetails: `/Cargo/GetCargoReceiptDetails`,
  CargoReceive: `/CargoTransaction/CargoReceive`,
  GetLuggageForDelivery: `/GetLuggageForDelivery`,
  CargoDelivery: `/CargoTransaction/CargoDelivery`,
  //cargo reports
  BookingReport: `/CargoReport/BookingReport`,
  ManifestReport: `/CargoReport/ManifestReport`,
  ReceiveReport: `/CargoReport/ReceiveReport`,
  DeliveryReport: `/CargoReport/DeliveryReport`,
  RemittanceReport: `/CargoReport/RemittanceReport`,
  getFranchiseeCommissionSummaryReport: '/GeneralReport/FranchiseeCommissionSummaryReport',
  getFranchiseeDepRecDivisionReport: '/GeneralReport/FranchiseeDepRecDivisionReport',
  //Cargo ID proof Type
  IDProofMaster: `/Common/IDProofMasterListAll`,
  //cargo booking
  CargoBookingCharge: `/Cargo/CargoBookingCharges`,
  CargoBookingSave: `/CargoTransaction/CargoBooking`,
  CargoBookingSnapshotsSave: `/CargoTransaction/CargoBookingSnapshotsSave`,
  GetManifestDetails: `/Cargo/GetManifestDetails`,
  CargoVehicleDetails: `/Cargo/CargoVehicleDetails`,
  DriverConductorListAll: `/Common/DriverConductorListAll`,
  CargoDisatch: `/CargoTransaction/CargoDisatch`,
  CargoDisatchV2: `/CargoTransaction/CargoDisatchV2`,
  GetCargoReceiptDetails: `/Cargo/GetCargoReceiptDetails`,
  CargoReceive: `/CargoTransaction/CargoReceive`,
  GetLuggageForDelivery: `/GetLuggageForDelivery`,
  CargoDelivery: `/CargoTransaction/CargoDelivery`,
  //cargo reports
  BookingReport: `/CargoReport/BookingReport`,
  ManifestReport: `/CargoReport/ManifestReport`,
  ReceiveReport: `/CargoReport/ReceiveReport`,
  DeliveryReport: `/CargoReport/DeliveryReport`,
  RemittanceReport: `/CargoReport/RemittanceReport`,
  getDcRemittanceReport: `/CargoReport/DCRemittanceReport`,
  getUserRemittanceReport: `/CargoReport/GetUserRemittanceDetails`,
  getUserRemittanceUpdate: `/CargoReport/UserRemittanceUpdate`,
  getInsurenceCollectedReport: `/CargoReport/InsuranceCollectionReport`,
  getDemurragesAmountCollectionReport: `/CargoReport/DemurrageCollectionReport`,
  getRouteAnalysisReport: `/CargoReport/RouteAnalysisReport`,
  getRouteAnalysisReport: `/CargoReport/RouteAnalysisReport`,
  getProductAnalysisReport: `/CargoReport/ProductAnalysisReport`,
  getDailyParcelRevenueCollectionReport: `/CargoReport/DailyParcelRevenueReport`,
  getGSTRReport: `/CargoReport/GSTReport`,
  getManifestDashboardReport: `/CargoReport/ManifestDashboardReport`,
  getReceiveDashboardReport: `/CargoReport/ReceiveDashboardReport`,
  getReceiveDashboardHyperlinkReport: `/CargoReport/ReceiveDashboardHyperlinkReport`,
  getDeliveryDashboardReport: `/CargoReport/DeliveryDashboardReport`,
  getDeliveryDashboardHyperlinkReport: `/CargoReport/DeliveryDashboardHyperlinkData`,
  getFranchiseeCommissionSummaryReport: '/GeneralReport/FranchiseeCommissionSummaryReport',
  getFranchiseeDepRecDivisionReport: '/GeneralReport/FranchiseeDepRecDivisionReport',

  getTripListAllWithUserPrev: '/RouteService/GetTripListAllWithUserPrev',
  getServiceCancelTicketOtherReport: '/OtherReport/ServiceCancelTicketReport',
  getServiceCancelTicketGenReport: '/GeneralReport/ServiceCancelTicketReport',
  QuotaReleaseInsertUpdate: '/BlockSeat/QuotaRelease_InsertUpdate',
  getUnManifestedReport: `/CargoReport/UnmanifestedReport`,
  getDepoDivCorpWiseRevCollectionRpt: `/CargoReport/RevenueCollection`,
  getDailytRemittanceReport: `/CargoReport/DailyRemittanceReport`,
  getDepoDivCorpWiseRevCollectionRpt: `/CargoReport/RevenueCollection`,
  getDailytRemittanceReport: `/CargoReport/DailyRemittanceReport`,
  getDepotwiseManifestedCommissionReport: `/CargoReport/DepotwiseManifestedCommissionReport`,
  getBookingSummaryReport: `/CargoReport/BookingSummaryReport`,
  getBusinessFecilitatorReport: `/CargoReport/BusinessFacilitatorCommissionReport`,
  getDayWiseCommPayableReport: `/CargoReport/DayWiseCommissionPayableReport`,
  getComissionListReport: `/CargoReport/DaywiseCommisionData`,
  KiloMetersetup: '/CargoReport/KiloMetersetup',
  KiloMetersetupInsertUpdate: '/CargoReport/KiloMetersetupInsertUpdate',
  getMisRouteListReport: '/CargoReport/MisRouteReport',
  getRevenueReceivableReport: '/CargoReport/RevenueReceivableReport',
  getPayableRevenueSharingReport: '/CargoReport/PayableRevenueSharingReport',
  getReceivableRevenueSharingReport: '/CargoReport/ReceivableRevenueSharingReport',
  getRevenuePayableReport: '/CargoReport/RevenuePayableReport',
  //manifest
  getManifestPrintDetails: `/Cargo/ManifestPrintDetails`,

  getBlockUnblocklogReportData: `/GeneralReport/BlockUnblocklogReport`,
  serviceQuotaReleaseInsertUpdate: '/RouteService/ServiceQuotaRelease_InsertUpdate',
  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getCargoBookingConfiguration: '/Cargo/CargoBookingConfiguration',
  getIssueCargoPPRListAll: '/Stock/IssueCargoPPRListAll',
  getBranchCurrentCargoPPR: '/Stock/BranchCurrentCargoPPR',
  CargoPPRDetailsInsertUpdate: '/Stock/CargoPPRDetailsInsertUpdate',
  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getVacancySeatReport: '/Report/VacancySeatReport',

  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,

  //Content management system apis
  getCmsMenu: `/resource/getCMSmenuContent`,
  getCmsMainBannerImage: `/resource/getBannerImg`,
  insertCmsMainBannerImage: `/resource/uploadBannerImg`,
  getReservationTerms: `/resource/getReservationTermsContent`,
  uploadReservationTerms: `/uploadReservationTermsContent`,
  deleteReservationTerms: `/resource/deleteReservationTermsContent`,
  getMarquee: `/resource/getMarqueeContent`,
  uploadGuestUserTerms: `/resource/uploadGuestUserContent`,
  getCargoBookingConfiguration: '/Cargo/CargoBookingConfiguration',
  //Product Type 
  CargoConsignmentList: `/Cargo/CargoConsignmentList`,
  ProductTypeInsertUpdate: `/Cargo/ProductTypeInsertUpdate`,
  //Transhipment charge
  TranshipmentListAll: `/Cargo/TranshipmentListAll`,
  TranshipmentChargeInsertUpdate: `/Cargo/TranshipmentChargeInsertUpdate`,
  getIssueCargoPPRListAll: '/Stock/IssueCargoPPRListAll',
  getIssueCargoPPRListAll: '/Stock/IssueCargoPPRListAll',
  getBranchCurrentCargoPPR: '/Stock/BranchCurrentCargoPPR',
  CargoPPRDetailsInsertUpdate: '/Stock/CargoPPRDetailsInsertUpdate',
  //Cargo
  getConsignmentList: `/Cargo/CargoConsignmentList`,
  getCargoWeightListAll: `/Cargo/CargoWeightListAll`,
  weightInsertUpdate: `/Cargo/CargoWeightInsertUpdate`,
  getCargoKiloMeterListAll: '/Cargo/CargoKiloMeterListAll',
  kiloMeterInsertUpdate: `/Cargo/CargoKiloMeterInsertUpdate`,
  getCargoCrewListAll: '/Cargo/CrewIncentiveListAll',
  CrewIncentiveInsertUpdate: `/Cargo/CrewIncentiveInsertUpdate`,
  getCargoTransportChargeListAll: '/Cargo/TransportchargeListAll',
  TransportchargeInsertUpdate: `/Cargo/TransportchargeInsertUpdate`,
  getLoadingUnloadingListAll: '/Cargo/LoadingUnloadingListAll',
  LoadingUnloadingChargeInsertUpdate: '/Cargo/LoadingUnloadingChargeInsertUpdate',

  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getVacancySeatReport: '/Report/VacancySeatReport',

  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,

  getBlockUnblocklogReportData: `/GeneralReport/BlockUnblocklogReport`,
  serviceQuotaReleaseInsertUpdate: '/RouteService/ServiceQuotaRelease_InsertUpdate',
  //Content management system apis
  getCmsMenu: `/resource/getCMSmenuContent`,
  getCmsMainBannerImage: `/resource/getBannerImg`,
  insertCmsMainBannerImage: `/resource/uploadBannerImg`,
  getReservationTerms: `/resource/getReservationTermsContent`,
  uploadReservationTerms: `/uploadReservationTermsContent`,
  deleteReservationTerms: `/resource/deleteReservationTermsContent`,
  getMarquee: `/resource/getMarqueeContent`,
  getGuestUsersTerms: `/resource/getGuestUsersTermsContent`, //getGuestUserContent
  getRefundRulesAndClaimsContent: '/resource/getRefundRulesAndClaimsContent',
  uploadGuestUserTerms: `/resource/uploadGuestUserContent`,
  getPopularDestination: `/resource/getPopulardestination`,
  getBookingCounter: `/resource/getBookingCounterContent`,
  getCmsCityList: `/resource/getStaticCityList`,
  getWelcome: `/resource/getWelcomeContent`,
  getContact: `/resource/getContactContent`,
  getPopupImage: `/resource/getPopupImg`,


  getGSOContent: `/resource/getGSOContent`,
  addGSOContent: `/resource/addGSOContent`,
  deleteGSOContent: `/resource/deleteGSOContent`,
  TranshipmentChargeInsertUpdate: `/Cargo/TranshipmentChargeInsertUpdate`,
  getIssueCargoPPRListAll: '/Stock/IssueCargoPPRListAll',
  getIssueCargoPPRListAll: '/Stock/IssueCargoPPRListAll',
  getBranchCurrentCargoPPR: '/Stock/BranchCurrentCargoPPR',
  CargoPPRDetailsInsertUpdate: '/Stock/CargoPPRDetailsInsertUpdate',
  //Cargo
  getConsignmentList: `/Cargo/CargoConsignmentList`,
  getCargoWeightListAll: `/Cargo/CargoWeightListAll`,
  weightInsertUpdate: `/Cargo/CargoWeightInsertUpdate`,
  getCargoKiloMeterListAll: '/Cargo/CargoKiloMeterListAll',
  getInsuranceChargeTable: `/Cargo/InsuranceChargeListAll`,
  getInsuranceChargeInsertUpdate: `/Cargo/InsurancechargeInsertUpdate`,
  getDemurrageChargeTable: `/Cargo/DemurrageListAll`,
  getDemurrageChargeInsertUpdate: `/Cargo/DemurrageChargeInsertUpdate`,
  getShipmentWeightListAll: `/Cargo/ShipmentWeightLimitListAll`,
  getShipmentWeightInsertUpdate: `/Cargo/ShipmentWeightInsertUpdate`,

  getCargoKiloMeterListAll: '/Cargo/CargoKiloMeterListAll',
  kiloMeterInsertUpdate: `/Cargo/CargoKiloMeterInsertUpdate`,
  getCargoCrewListAll: '/Cargo/CrewIncentiveListAll',
  CrewIncentiveInsertUpdate: `/Cargo/CrewIncentiveInsertUpdate`,
  getCargoTransportChargeListAll: '/Cargo/TransportchargeListAll',
  TransportchargeInsertUpdate: `/Cargo/TransportchargeInsertUpdate`,
  getFranchiseeCommissionSummaryReport:
    "/GeneralReport/FranchiseeCommissionSummaryReport",
  getFranchiseeDepRecDivisionReport:
    "/GeneralReport/FranchiseeDepRecDivisionReport",
  getTripListAllWithUserPrev: "/RouteService/GetTripListAllWithUserPrev",
  getServiceCancelTicketOtherReport: "/OtherReport/ServiceCancelTicketReport",
  QuotaReleaseInsertUpdate: "/BlockSeat/QuotaRelease_InsertUpdate",

  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  serviceQuotaReleaseInsertUpdate: '/RouteService/ServiceQuotaRelease_InsertUpdate',
  getLoadingUnloadingListAll: '/Cargo/LoadingUnloadingListAll',
  getFranchiseeCommissionSummaryReport: '/GeneralReport/FranchiseeCommissionSummaryReport',
  getFranchiseeCommissionSummaryReportV2: '/GeneralReport/FranchiseeCommissionSummaryReportV2',
  getFranchiseeDepRecDivisionReport: '/GeneralReport/FranchiseeDepRecDivisionReport',
  getTripListAllWithUserPrev: '/RouteService/GetTripListAllWithUserPrev',
  getServiceCancelTicketOtherReport: '/OtherReport/ServiceCancelTicketReport',
  getServiceCancelTicketGenReport: '/GeneralReport/ServiceCancelTicketReport',
  QuotaReleaseInsertUpdate: '/BlockSeat/QuotaRelease_InsertUpdate',

  getCounterWiseBookingComparisonReport: '/GeneralReport/CounterWiseBookingComparisonReport',
  getServiceWiseSeatAvailabilityReport: '/GeneralReport/ServiceWiseSeatAvailabilityReport',
  getTicketBlockConsumptionReport: '/GeneralReport/TicketBlockConsumptionReport',
  getHeighestBookingFromCityToCityReport: '/OtherReport/HeighestBookingFromCityToCityReport',
  getServiceTypeTransactionSummary: '/OtherReport/ServiceTypeTransactionSummary',


  getBlockUnblocklogReportData: `/GeneralReport/BlockUnblocklogReport`,
  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getVacancySeatReport: '/Report/VacancySeatReport',
  //Content management system apis
  getCmsMainBannerImage: `/resource/getBannerImg`,
  insertCmsMainBannerImage: `/resource/uploadBannerImg`,
  getReservationTerms: `/resource/getReservationTermsContent`,
  uploadReservationTerms: `/uploadReservationTermsContent`,
  deleteReservationTerms: `/resource/deleteReservationTermsContent`,
  getMarquee: `/resource/getMarqueeContent`,
  uploadGuestUserTerms: `/resource/uploadGuestUserContent`,
  getPopularDestination: `/resource/getPopulardestination`,
  getBookingCounter: `/resource/getBookingCounterContent`,
  getCmsCityList: `/resource/getStaticCityList`,

  getGSOContent: `/resource/getGSOContent`,
  addGSOContent: `/resource/addGSOContent`,
  deleteGSOContent: `/resource/deleteGSOContent`,
  getStartingFromData: '/tours/getStartingFromData',
  getAccoTypeData: `/tours/getAccoTypeData`,
  getVariantData: '/tours/getVariantData',
  getSearchRouteFromTownID: '/tours/getSearchRouteFromTownID',
  getBusID: '/tours/getBusID',
  getSeatLayoutData: '/tours/getSeatLayoutData',
  getPickUpID: '/tours/getPickUpID',
  getUnusedStockReport: '/OtherReport/UnusedStockReport',
  getTripSheetSummaryReport: '/OtherReport/TripSheetSummaryReport',
  getUserLogSummaryReport: "/OtherReport/UserLogSummaryReport",
  getRevCollRepoCorpWise: `/GeneralReport/GetRevCollRepoCorpWise`,
  getRefreshSearchCache: '/BookingSearch/RefreshSearchCache',
  getLevelDepartmentsList: '/Master/LevelDepartmentsList',


  //Product Type 
  CargoConsignmentList: `/Cargo/CargoConsignmentList`,
  ProductTypeInsertUpdate: `/Cargo/ProductTypeInsertUpdate`,
  //Transhipment charge
  TranshipmentListAll: `/Cargo/TranshipmentListAll`,
  TranshipmentChargeInsertUpdate: `/Cargo/TranshipmentChargeInsertUpdate`,
  getBoardingPointwiseDetail: '/GeneralReport/BoardingPointwiseDetail',
  //Casual Contract
  generateVoucher: `/BusHire/APIGenerateVoucher?`,
  updateVoucher: `/BusHire/APIUpdateVoucher?`,
  getRateConfig: `/BusHire/APIGetRatesConfig3?`,
  getBusHireConfig: `/BusHire/APIGetBusHireConfig?`,
  getVehicleTypes: `/BusHire/APIGetVehicleTypesV2`,
  getVehicleTypeMasterList: `/BusHire/APIGetVehicleTypes`,
  getCasualContractDatalist: `/BusHire/APIGetVoucherDetailsByCCDate`,
  voucherAcceptReject: `/BusHire/APIVoucherAcceptReject?`,
  cashReceivedInsertUpdate: `/BusHire/BusHireCashReceivedInsertUpdate?`,
  //allocateVehicleInsertUpdate: `/BusHire/BusHireBusScheduleInsertUpdate?`,
  allocateVehicleInsertUpdate: `/BusHire/BusHireBusScheduleInsertUpdateV2?`,
  getAllocatedVehicleList: `/BusHire/GetBusHireBusSchedule?`,
  getServiceCancelTicketGenReport: '/GeneralReport/ServiceCancelTicketReport',
  getCounterWiseBookingComparisonReport: '/GeneralReport/CounterWiseBookingComparisonReport',
  getServiceWiseSeatAvailabilityReport: '/GeneralReport/ServiceWiseSeatAvailabilityReport',
  getTicketBlockConsumptionReport: '/GeneralReport/TicketBlockConsumptionReport',
  getHeighestBookingFromCityToCityReport: '/OtherReport/HeighestBookingFromCityToCityReport',
  getServiceTypeTransactionSummary: '/OtherReport/ServiceTypeTransactionSummary',
  QuotaReleaseInsertUpdate: '/BlockSeat/QuotaRelease_InsertUpdate',
  getVacancySeatReport: '/Report/VacancySeatReport',
  getEarningReportHeadwise: '/CargoReport/EarningReportHeadwise',
  generateBookingId: `/BusHire/BusHireGeneratePaymentBookingID?`,
  startJourneyAllocateVehicle: `/BusHire/BusHireBusScheduleStartJourneyV2?`,
  getVoucherDetailsByVooucherId: `/BusHire/APIGetVoucherDetailsByVoucherID?`,

  getBlockConfirmListing: `/BlockSeat/BlockConfirmListing`,
  getDivisionServiceWiseRevSummReport: '/GeneralReport/DivisionServiceWiseRevSummReportV2',

  getVacancySeatReport: '/Report/VacancySeatReport',
  getRevCollRepoCorpWise: `/GeneralReport/GetRevCollRepoCorpWise`,
  getClearCityPairCache: '/RouteService/ClearCityPairCache',
  //Tariff Master
  addUpdateTariffMaster: `/BusHire/APIRatesInsertUpdate`,
  getRateTariffMasterList: `/BusHire/APIGetRatesConfig2V2`,//
  getAPIVoucherReConcile: '/BusHire/APIVoucherReConcile',
  updateCancelVoucher: '/BusHire/CancelVoucher',
  getUnusedStockReport: '/OtherReport/UnusedStockReport',
  getTripSheetSummaryReport: '/OtherReport/TripSheetSummaryReport',
  getUserLogSummaryReport: "/OtherReport/UserLogSummaryReport",

  getStartingFromData: '/KSTDCDataAPI/SelectCityTownFrom',
  getAccoTypeData: `/KSTDCDataAPI/GetAccoType`,
  getVariantData: '/KSTDCDataAPI/GetVariantCode',
  getSearchRouteFromTownID: '/KSTDCDataAPI/SelectAllPrmCityTownIDFrom',
  getBusID: '/KSTDCDataAPI/GetBusID',
  getSeatLayoutData: '/KSTDCDataAPI/getSeatLayoutData',
  getPickUpID: '/KSTDCDataAPI/GetPickUpID',
  getClearCityPairCache: '/RouteService/ClearCityPairCache',
  getRevCollRepoCorpWise: `/GeneralReport/GetRevCollRepoCorpWise`,
  getFooterHeadingContent: `/resource/getFooterHeadingContent`,
  //cash receive
  getCashReceiveReceiptList: `/BusHire/GetBusHireCashReceived?`,
  //vehicleType master
  addInsertUpdateVehicleTypeMaster: `/BusHire/APIVehicleInsertUpdate`,
  getLevelDepartmentsList: '/Master/LevelDepartmentsList',

  getEarningReportHeadwise: '/CargoReport/EarningReportHeadwise',
  getFooterHeadingContent: `/resource/getFooterHeadingContent`,
  getLevelDepartmentsList: '/Master/LevelDepartmentsList',

  generateVoucher: `/CasualContract/APIGenerateVoucher?`,
  updateVoucher: `/CasualContract/APIUpdateVoucher?`,
  getRateConfig: `/CasualContract/APIGetRatesConfig3?`,
  getBusHireConfig: `/CasualContract/APIGetBusHireConfig?`,
  getVehicleTypes: `/CasualContract/APIGetVehicleTypesV2`,
  getVehicleTypeMasterList: `/CasualContract/APIGetVehicleTypes`,
  getCasualContractDatalist: `/CasualContract/APIGetVoucherDetailsByCCDateV2`,
  voucherAcceptReject: `/CasualContract/APIVoucherAcceptReject?`,
  voucherRejectApproval: `/CasualContract/APIRejectApproval?`,
  cashReceivedInsertUpdate: `/CasualContract/BusHireCashReceivedInsertUpdate?`,
  //allocateVehicleInsertUpdate: `/CasualContract/BusHireBusScheduleInsertUpdate?`,
  //allocateVehicleInsertUpdate: `/CasualContract/BusHireBusScheduleInsertUpdateV2?`,
  allocateVehicleInsertUpdate: `/CasualContract/BusHireBusScheduleInsertUpdateV4?`,
  getAllocatedVehicleList: `/CasualContract/GetBusHireBusSchedule?`,
  generateBookingId: `/CasualContract/BusHireGeneratePaymentBookingID?`,
  startJourneyAllocateVehicle: `/CasualContract/BusHireBusScheduleStartJourneyV2?`,
  getVoucherDetailsByVooucherId: `/CasualContract/APIGetVoucherDetailsByVoucherID?`,
  updateVoucherDepotDivision: `/CasualContract/APIUpdateDepoDetails?`,
  updateBreakdownDetails: `/CasualContract/APIBusHireBusBreakdownUpdate?`,
  getBreakdownHistory: `/CasualContract/APIGetBusHireBusBreakdownHistory`,
  updatePreponePostponeDetails: `/CasualContract/APIBusHirePreponePostponeInsert?`,
  updateExtendCurtailDetails: `/CasualContract/APIBusHireExtCurt_Update?`,
  saveReconcileDetails: `/CasualContract/ReconsileSave?`,
  getFareScheduleWiseDetails: `/CasualContract/GetFareScheduleWise?`,
  //Tariff Master
  addUpdateTariffMaster: `/CasualContract/APIRatesInsertUpdate`,
  getRateTariffMasterList: `/CasualContract/APIGetRatesConfig2V2`,//
  getAPIVoucherReConcile: '/CasualContract/APIVoucherReConcile',
  updateCancelVoucher: '/CasualContract/CancelVoucherV2',
  getClearCityPairCache: '/RouteService/ClearCityPairCache',
  getRevCollRepoCorpWise: `/GeneralReport/GetRevCollRepoCorpWise`,
  getLevelDepartmentsList: '/Master/LevelDepartmentsList',
  deleteVehicle: `/CasualContract/APIVehicleDelete`,

  getFooterHeadingContent: `/resource/getFooterHeadingContent`,
  getBoardingPointwiseDetail: '/GeneralReport/BoardingPointwiseDetail',
  getBoardingPointTripcodewiseDetail: '/GeneralReport/BoardingPointTripcodewiseDetail',
  getUserLogSummaryReport: "/OtherReport/UserLogSummaryReport",
  getTravelinfoReport: `/OtherReport/TravelInfoReport`,
  getUnusedStockReport: '/OtherReport/UnusedStockReport',
  getTripSheetSummaryReport: '/OtherReport/TripSheetSummaryReport',
  getStatementOfAccountsForSaleOfTickets: `/OtherReport/StatementOfAccountsReport`,
  getBusStationWiseServicesAndFranchiseeReport: `/GeneralReport/BusStandWiseServiceNFranchiseeRpt`,
  getBookingSummaryForGivenPeriodReport: `/GeneralReport/GetBookingSummaryGivenPeriod`,
  getPOSBookingModifyOrderID: '/POSBookingModify/GetPOSBookingModifyOrderID',
  updatePOSModCancel: '/POSBookingModify/POSModCancel',
  getPOSModCheckAndConfirm: '/POSBookingModify/POSModCheckAndConfirm',
  getFeedbackRatingReport: '/Feedback/APIFeedbackRatingReport',
  getTransStatusList: `/GeneralReport/RefundStatusList`,
  updatePOSSeatHold: `/POSBooking/POSSeatHold`,
  updatePOSCheckAndConfirm: `/POSBooking/POSPSCheckAndConfirm`,
  updatePOSHoldRelease: '/POSBooking/POSCancelNHoldRelease',
  updatePOSSeatHoldReturn: `/POSOnwardReturnBooking/POSSeatHold`,
  updatePOSCheckAndConfirmReturn: `/POSOnwardReturnBooking/POSPSCheckAndConfirm`,
  updatePOSHoldReleaseReturn: '/POSOnwardReturnBooking/POSCancelNHoldRelease',
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  //Cargo TopUp Apis
  getCargoTopUpList: `/Topup/GetCargoTopupdetails`,
  getCargoAddTopUp: `/Topup/AddCargoTopUp`,
  getCargoViewTopUp: `/Topup/ViewCargoTopupdetails`,
  getSeniorFare: '/KSTDCDataAPI/getSeniorFare',
  getFare: '/KSTDCDataAPI/GetFare',
  updateBusSeatsBlocking: '/KSTDCTranAPI/BusSeatsBlocking',
  updateBusSeatsUpdate: '/KSTDCTranAPI/BusSeatsUpdate',
  getFetchPNRDetails: '/KSTDCDataAPI/FetchPNRDetails',
  getPNRStatus: '/KSTDCDataAPI/GetPNRStatus',
  getBusSeatsCancellationCharges: '/KSTDCTranAPI/BusSeatsCancellationCharges',
  getBusSeatsCancellation: '/KSTDCTranAPI/BusSeatsCancellation',
  getPNRWiseBookingCancelRpt: '/KSTDCDataAPI/PNRWiseBookingCancelRpt',
  getPNRWiseTransRpt: '/KSTDCDataAPI/PNRWiseTranRpt',
  getAdhocCancellation: '/KSTDCTranAPI/AdhocCancellation',
  getAdhocPer: '/KSTDCDataAPI/GetAdhocPer',
  getAdhocDetailRpt: '/KSTDCDataAPI/GetAdhocDetailRpt',
  getBkgSummaryRpt: '/KSTDCDataAPI/GetBkgSummaryRpt',
  getKSTDCCityList: '/KSTDCDataAPI/GetUserCityList',
  getListofPaymentDoneModPending: '/POSBookingModify/GetListofPaymentDoneModPending',
  updatePOSRefund: '/POSBookingModify/POSRefund',
  getPNRWiseBookingCancelRpt: '/KSTDCDataAPI/PNRWiseBookingCancelRpt',
  getAdhocDetailRpt: '/KSTDCDataAPI/GetAdhocDetailRpt',
  getKSTDCCityList: '/KSTDCDataAPI/GetUserCityList',
  getAdhocCancellation: '/KSTDCTranAPI/AdhocCancellation',
  getAdhocPer: '/KSTDCDataAPI/GetAdhocPer',
  getFeedbackRatingReport: '/Feedback/APIFeedbackRatingReport',
  getTransStatusList: `/GeneralReport/RefundStatusList`,
  getServiceCancelRpt: '/KSTDCDataAPI/ServiceCancelRpt',
  getKSTDCCityList: '/KSTDCDataAPI/GetUserCityList',
  getFeedbackRatingReport: '/Feedback/APIFeedbackRatingReport',
  getTransStatusList: `/GeneralReport/RefundStatusList`,
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  getRevenueRealizedThroughAcPassengerStageCarrierServices: `/OtherReport/RevenueRealizedSummaryReport`,
  getDailyRevenueForTheMonth: `/GeneralReport/GetDailyRevMonthlyReport`,
  getDivisionwiseMonthlyCollection: `/GeneralReport/GetDivisionWiseRevMonthlyReport`,
  getPOSTransactionReport: `/GeneralReport/GetPOSBookingReport`,
  getRevenueThroughAWATAR: `/OtherReport/RevenueRealizedSummaryReport`,
  getKSTDCTrackTicketList: '/KSTDCDataAPI/GetPNRSearchList',
  getKSTDCTrackTicket: '/KSTDCDataAPI/TrackTicket',
  getFeedbackRatingReport: '/Feedback/APIFeedbackRatingReport',
  getTransStatusList: `/GeneralReport/RefundStatusList`,
  getAnnualRevSeatsRpt: `/GeneralReport/GetAnnualRevSeatsRpt`,
  getDivisionWiseRevRetainedReport: `/AccountReport/GetDivisionWiseRevRetainedReport`,
  getFeedbackRatingReport: '/Feedback/APIFeedbackRatingReport',
  getTransStatusList: `/GeneralReport/RefundStatusList`,
  //Cargo TopUp Apis
  getCargoTopUpList: `/Topup/GetCargoTopupdetails`,
  getCargoAddTopUp: `/Topup/AddCargoTopUp`,
  getCargoViewTopUp: `/Topup/ViewCargoTopupdetails`,
  getKSTDCTrackTicket: '/KSTDCDataAPI/TrackTicket',
  getPNRWiseBookingCancelRpt: '/KSTDCDataAPI/PNRWiseBookingCancelRpt',
  getAdhocDetailRpt: '/KSTDCDataAPI/GetAdhocDetailRpt',
  getServiceCancelRpt: '/KSTDCDataAPI/ServiceCancelRpt',
  getPNRWiseBookingCancelRpt: '/KSTDCDataAPI/PNRWiseBookingCancelRpt',
  getPNRWiseBookingCancelRpt: '/KSTDCDataAPI/PNRWiseBookingCancelRpt',
  getAdhocDetailRpt: '/KSTDCDataAPI/GetAdhocDetailRpt',
  getServiceCancelRpt: '/KSTDCDataAPI/ServiceCancelRpt',
  getPNRWiseBookingCancelRpt: '/KSTDCDataAPI/PNRWiseBookingCancelRpt',
  getAdhocDetailRpt: '/KSTDCDataAPI/GetAdhocDetailRpt',
  getServiceCancelRpt: '/KSTDCDataAPI/ServiceCancelRpt',
  getPNRWiseTransRpt: '/KSTDCDataAPI/PNRWiseTranRpt',
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  getDivisionWiseRevRetainedReport: `/AccountReport/GetDivisionWiseRevRetainedReport`,
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  getGST_TDSDeductRpt: `/OtherReport/GetGST_TDSDeductRpt`,
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  getAgentBalanceSummary: `/AccountReport/GetAgentBalanceSummary`,
  getFranchiseeTopupRpt: `/AccountReport/GetFranchiseeTopupRpt`,
  getFranchiseeCommissionSummaryReport_Monthly: `/AccountReport/FranchiseeCommissionSummaryReport_Monthly`,
  getFranchiseeCommissionSummaryReport_Daily: `/GeneralReport/FranchiseeCommissionSummaryReport_Daily`,
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  getBusStandWiseFranchiseeCommGSTTDSRpt: '/GeneralReport/BusStandWiseFranchiseeCommGSTTDSRpt',
  getFeedbackRatingReport: '/Feedback/APIFeedbackRatingReport',
  getTransStatusList: `/GeneralReport/RefundStatusList`,
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  //Cargo TopUp Apis
  getCargoTopUpList: `/Topup/GetCargoTopupdetails`,
  getCargoAddTopUp: `/Topup/AddCargoTopUp`,
  getCargoViewTopUp: `/Topup/ViewCargoTopupdetails`,
  getCancellationSummaryData: '/OtherReport/CancellationSummarySlabBasedReport',
  getOnlineCustGstRpt: '/OnlineReports/OnlineCustGstRpt',
  //cash receive
  getCashReceiveReceiptList: `/CasualContract/GetBusHireCashReceived?`,
  //vehicleType master
  addInsertUpdateVehicleTypeMaster: `/CasualContract/APIVehicleInsertUpdate`,
  getOnlineCustGstRpt: '/OnlineReports/OnlineCustGstRpt',
  getOnlineCustGstRpt: '/OnlineReports/OnlineCustGstRpt',


  getDailyRevenueForTheMonth: `/GeneralReport/GetDailyRevMonthlyReport`,
  getServiceWiseSeatAvailabilityReport: '/GeneralReport/ServiceWiseSeatAvailabilityReport',
  getStationWiseServiceType: `/GeneralReport/StationDepotWiseReportResponse`,
  getDailyStockConsumptionReport: `/GeneralReport/StockConsumptionReport`,
  getFranchiseeCommissionSummaryReport_Daily: `/GeneralReport/FranchiseeCommissionSummaryReport_Daily`,
  getVacancySeatReport: '/Report/VacancySeatReport',
  getAdvanceBookedSeatsRevenueReport: `/GeneralReport/GetAdvanceBookedSeatsRevenueReport`,
  getDivisionwiseMonthlyCollection: `/GeneralReport/GetDivisionWiseRevMonthlyReport`,
  getSpecialIncentivesMasterTable: `/GeneralReport/SpecialIncentive_MasterDetails`,
  getTicketBlockConsumptionReport: '/GeneralReport/TicketBlockConsumptionReport',
  getBookedSeatsSummaryDepotWiseReport: `/OtherReport/BookedSeatsSummaryDepotWise`,
  getBookedSeatDepotWiseReport: `/GeneralReport/BookedSeatDepotWiseOccPerReport`,
  getBlockTicketReport: `/OtherReport/BlockTicketReport`,
  getCancelTktAdvanceBookStopReport: `/OtherReport/CancelTktAdvanceBookStopReport`,
  getFranchiseeCommissionDiffReportData: `/OtherReport/FranchiseeCommissionDifferenceReport`,
  getGST_TDSDeductRpt: `/OtherReport/GetGST_TDSDeductRpt`,
  getStockSkipDetailsReport: `/OtherReport/StockSkipDetailsReport`,
  getLevySlabwiseCollectionSeatsBookedSummary: `/OtherReport/LevySlabColl_SeatsBooked`,
  getRevenueThroughAWATAR: `/OtherReport/RevenueRealizedSummaryReport`,
  getHeighestBookingFromCityToCityReport: '/OtherReport/HeighestBookingFromCityToCityReport',
  getForeignDomesticTravelInfoReport: `/GeneralReport/ForeignDomesticTravelInfoReport`,
  getAgentBalanceSummary: `/AccountReport/GetAgentBalanceSummary`,
  getRevenueRealizedThroughAcPassengerStageCarrierServices: `/OtherReport/RevenueRealizedSummaryReport`,
  getFranchiseeTopupRpt: `/AccountReport/GetFranchiseeTopupRpt`,
  getBusStandWiseFranchiseeCommGSTTDSRpt: '/GeneralReport/BusStandWiseFranchiseeCommGSTTDSRpt',
  getFranchiseeCommissionSummaryReport_Monthly: `/AccountReport/FranchiseeCommissionSummaryReport_Monthly`,
  getDivisionWiseRevRetainedReport: `/AccountReport/GetDivisionWiseRevRetainedReport`,
  getServiceCancAfterJourneyDateReportData: `/OtherReport/ServiceCnclJourneyDateReport`,
  getCrewAppLoginLogReport: `/Crew/ThipSheetGeneratedByCrewList`,

  //Cargo TopUp Apis
  getCargoTopUpList: `/Topup/GetCargoTopupdetails`,
  getCargoAddTopUp: `/Topup/AddCargoTopUp`,
  getCargoViewTopUp: `/Topup/ViewCargoTopupdetails`,
  //paymentGateway list
  getPaymentGatewayList: `/Report/GetPGType`,
  getPGTransactionStatusReportData: `/OnlineReports/TicketPendingRefundReportRefundDtWise`,
  getPOSPSCheck: '/POSBooking/POSPSCheck',

  getServiceTypeTransactionSummary: '/OtherReport/ServiceTypeTransactionSummary',
  getDateWiseRevenueReport: `/GeneralReport/GetDateWiseRevenueReport`,
  getCounterWiseBookingComparisonReport: '/GeneralReport/CounterWiseBookingComparisonReport',
  getFareMasterSummaryReport: `/GeneralReport/FareMasterSummaryReport`,
  getAvlTripDates: '/KSTDCDataAPI/AvailableTripDates',
  getPOSTransactionReport: `/GeneralReport/GetPOSBookingReport`,
  getPOSBankGatewayReportData: `/GeneralReport/GetPOSFailureTxnReport`,
  getAdhocCancellationWithRef: '/KSTDCTranAPI/AdhocCancellationWithRef',
  //Link Place list
  getLinkPlace: `/LinkCity/GetCityLinkPair`,
  getLinkPlaceInsertUpdate: `/LinkCity/SetCityLinkPair`,
  GetPDGenAIReport: '/OtherReport/GetPDGenAIReport',
  getAdhocCancellationWithRef: '/KSTDCTranAPI/AdhocCancellationWithRef',
  getCancelTripSelect: '/KSTDCTranAPI/CancelTripSelect',
  //reports
  getPassSummaryReport: `/OtherReport/PassSummaryReport`,
  getPassDetailReport: `/OtherReport/MonthlyPassDetailsReport`,
  //cash receive
  getCashReceiveReceiptList: `/CasualContract/GetBusHireCashReceived?`,
  //vehicleType master
  addInsertUpdateVehicleTypeMaster: `/CasualContract/APIVehicleInsertUpdate`,

  //cargo Reports
  BookingReportOldData: `/KarnatakaReport/KaBookingReport`,
  ManifestReportOldData: `/KarnatakaReport/KaManifestReport`,
  DeliveryReportOldData: `/KarnatakaReport/KaDeliveryReport`,
  ReceiveReportOldData: `/KarnatakaReport/KaReceiveReport`,
  getTourPackageTripWise: '/TourPackage/GetTourPackageTripWise',
  saveTourPackage: '/TourPackage/TourPackage',
  TrackTopUp: `/Topup/TrackTopUp`,
  getONBGWBSSReportDataWapp: `/OnlineReports/GetGatewayWiseBkgSuccessRpt_WA`,

};

export const isEmpty = (obj) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};
export function isEmpty2(value) {
  return (
    value == null ||                          // null or undefined
    value === false ||                        // false
    value === 0 ||                            // 0
    value === '' ||                           // empty string
    Number.isNaN(value) ||                    // NaN
    (Array.isArray(value) && !value.length) || // empty array
    (typeof value === 'object' && !Object.keys(value).length) // empty object
  );
}

export const Aws_S3_Bucket_info = {
  name: "crs-cargo-proof",
  region: "ap-southeast-1",
  AWSProfileName: "profile1",
  AWSAccessKey: "AKIAIH33XTFU3K5MRLTA",
  AWSSecretKey: "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",
};

export const SuccessfulMessage = (props) => {
  const { message } = props;
  return (
    <div className="successfulDialogWrap">
      <div className="icons">
        <CheckCircleIcon
          sx={{ width: "38px", height: "38px", color: "#3C763C" }}
        />
      </div>
      <div className="message">{message}</div>
    </div>
  );
};

export const colorsInChart = [
  "#FF9900",
  "#FF5200",
  "#2F89EB",
  "#4AACC7",
  "#8064A1",
];
export const LoginUser = {
  // userData
  IsMTPLAdmin: false,
  IsAdmin: false,
  IsBranchAdmin: false,
  CompanyID: "",
  UserID: "",
  CountryID: "",
  BranchName: "",
  CompanyName: "",
  UserName: "",
  RoleID: "",
  BranchID: "",
  CityID: "",
  StateID: "",
  MultiplePayments: 0,
  MobileLowerLimit: 0,
  MobileUpperLimit: 0,
  AccountingProductId: 0,
  IsCollBoyRequestPayment: 0,
  isSTACompanyID: 0,
  CounterID: 0,

  agentRight: {
    agents: false,
    agentVoucher: false,
    agentRecharge: false,
  },

  loading: false,
  loadingScreen: false,
  loginData: {},
  menuVisible: false,
  mainMenu: true,
  serviceMasterMenu: false,
  stockMasterMenu: false,
  othersMenu: false,
  routeMasterMenu: false,
  casualContractMenu: false,
  userConfigMenu: false,
  masterConfigMenu: false,
  bookingMenuOpen: false,
  roleData: [],
  layoutConfigMenu: false,
  fareMasterMenu: false,
  masterCodeValue: [],
};

export const paymentTypes = [
  { paymntTypeId: 1, paymntTypeName: "PAID" },
  { paymntTypeId: 2, paymntTypeName: "TOPAY" },
];
export const paymentTypesList = ["", "PAID", "TOPAY"];
export const chargeTypes = [
  { id: 1, name: "Per KG" },
  { id: 2, name: "Per unit" },
];
export const statusType = [
  { statusID: 0, status: "Active" },
  { statusID: 1, status: "Inactive" },
];
export const statusTypeCorp = [
  { statusID: 1, status: "Active" },
  { statusID: 0, status: "Inactive" },
];

export const serviceType = [
  { serviceTypeID: 0, serviceTypeName: "Regular" },
  { serviceTypeID: 1, serviceTypeName: "Special" },
];
export const reservableType = [
  { reservableID: 1, reservableName: "Active" },
  { reservableID: 0, reservableName: "Inactive" },
];
export const paymentStatus = [
  { paymentID: 1, payment: "Success" },
  { paymentID: 0, payment: "Failed" },
];
export const modeofPayment = [
  { modeofPaymentID: 1, paymentMode: "Netbanking" },
  { modeofPaymentID: 2, paymentMode: "Wallet" },
  { modeofPaymentID: 3, paymentMode: "Credit" },
  { modeofPaymentID: 0, paymentMode: "Debit" },
  { modeofPaymentID: 4, paymentMode: "UPI" },
];
export const PGTypeData = [{ name: "RAZORPAY", id: 0, value: 'Kotak Bank' }]


export const ConfimModalMessage = (props) => {
  const { msg } = props;
  return (
    <div className="agentDialogWrap">
      <div className="agentSvg">
        <HelpIcon sx={{ width: '36px', height: '36px', color: '#0086FF' }} />
      </div>
      <div className="agentMessage">
        {msg}
      </div>
    </div>
  )
}

export function getDates() {
  const baseDate = moment(window.getTime ? window.getTime() : new Date());

  return {
    yesterday: baseDate.clone().subtract(1, 'days').format('YYYY-MM-DD'),
    sixMonthsAgo: baseDate.clone().subtract(2, 'days').format('YYYY-MM-DD')
  };
}
